export const ROLE_TYPES = {
  ADMIN: {
    name: "admin",
    desc: "Администратор",
  },
  ADMIN_DATA: {
    name: "adminData",
    desc: "Администратор данных",
  },
  LEADER: {
    name: "leader",
    desc: "Руководитель",
  },
  HOLDING: {
    name: "holding",
    desc: "Холдинг",
  },
  DEALER: {
    name: "dealer",
    desc: "Дилер",
  },
  AUTOVAZ: {
    name: "autovaz",
    desc: "Сотрудник АВТОВАЗ",
  },
  LEADER_REGIONAL_SALES_MANAGER: {
    name: "leaderRegionalSalesManager",
    desc: "Руководитель региональных менеджеров по продажам",
  },
  LEADER_REGIONAL_SERVICE_MANAGER: {
    name: "leaderRegionalServiceManager",
    desc: "Руководитель региональных менеджеров по сервису",
  },
  REGIONAL_SERVICE_MANAGER: {
    name: "regionalServiceManager",
    desc: "Региональный менеджер по сервису",
  },
  REGIONAL_SALES_MANAGER: {
    name: "regionalSalesManager",
    desc: "Региональный менеджер по продажам",
  },
  REG_SERVICE_MANAGER: {
    name: "regServiceManager",
    desc: "РЕГ. МЕНЕДЖЕРА ПО СЕРВИСУ",
  },
  REG_SALES_MANAGER: {
    name: "regSalesManager",
    desc: "РЕГ. МЕНЕДЖЕРА ПО ПРОДАЖАМ",
  },
  CHECKER: {
    name: "checker",
    desc: "УОСОА",
  },
  BANK: {
    name: "bank",
    desc: "Сотрудник банка",
  },
  GUEST: {
    name: "guest",
    desc: "Гость",
  },
};
